import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoginResult } from '../../models/loginResult';
import { SnackbarService } from '../../services/snackbar.service';
import { StateService } from '../../services/state.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  email: string;
  newPasswordForm = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email])
  });

  constructor(
    private stateService: StateService,
    private _snackBar: SnackbarService,
    private _dialog: MatDialogRef<ForgotPasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslocoService,
  ) { }

  ngOnInit() {
    this.newPasswordForm.get('email')?.setValue(this.data.email);
  }

  public forgotPassword() {
    this.email = this.newPasswordForm.value.email;
    this.stateService.forgotPassword(this.email).subscribe(
      (result: LoginResult) => {
        console.log(result);
        this._dialog.close();
        this._snackBar.openSnackBar('Nytt lösenord skickat', 'OK');
      },
      (error: LoginResult) => {
        console.error(error);
        this._snackBar.openSnackBar(`Något gick fel... (${error.status}) `, 'Doh!');
      }
    );
  }
}
